import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import Layout from './views/layout.vue'
import NoResult from './components/404.vue'
import Home from './views/home.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'pc',
      component: Layout,
      beforeEnter (to, from, next) {
        const legalLocation = ['Canada', 'India']
        axios.defaults.baseURL = process.env.VUE_APP_AXIOS_o
        axios.get('/api/ip.php').then(res => {
          if (res.data.whitelist !== true) {
            if (legalLocation.includes(res.data.platform)) {
              next()
            }
          } else {
            next()
          }
        })
      },
      redirect: { name: 'home' },
      children: [
        { path: 'home', name: 'home', component: Home },
        { path: 'shop', name: 'shop', component: () => import('./views/shop.vue') },
        { path: 'shop/result', name: 'shop-success', component: () => import('./views/shop/result.vue') },
        { path: 'about', name: 'about', component: () => import('./views/about.vue') },
        { path: 'disclaimer', name: 'disclaimer', component: () => import('./views/disclaimer.vue') },
        { path: 'legal/:item', name: 'legal', component: () => import('./views/legalPrivacy.vue') }
        // { path: 'TermsOfService', name: 'TermsOfService', component: () => import('./views/legalTerms.vue') },
        // { path: 'legalRefund', name: 'legalRefund', component: () => import('./views/legalRefund.vue') }
      ]
    },
    {
      path: '*',
      name: 'NoResult',
      component: Layout,
      redirect: { name: 'NoResult' },
      children: [
        { path: '', name: 'NoResult', component: NoResult }
      ]
    }
  ]

})
// router.beforeEach(() => {
//   console.log('test')
//   this.$axios.get('/api/ip.php').then(res => {
//     console.log(res)
//   })
// })
export default router
